import React from 'react';
import { selectStyles } from '../leaseGeneralInvoiceReceipt/formUtils';

export const gridStyle = { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '18px' };

export const selectProps = {
    className: 'p-0',
    theme: (theme) => ({ ...theme, borderRadius: 5, padding: 9 }),
    menuPortalTarget: document.body,
    menuPlacement: 'auto',
    menuShouldScrollIntoView: false,
    styles: selectStyles,
};

export const Field = ({ label, required, error, children, className = '' }) => (
    <div className={className}>
        <div className="d-flex align-items-start">
            <label className="form-label pt-1 start" style={{ minWidth: 130 }}>
                {label}{required && <span className="text-danger"> *</span>}
            </label>
            <div className="w-100">{children}</div>
        </div>
        {error && <div className="text-danger small" style={{ marginLeft: 130 }}>{error}</div>}
    </div>
);

export const Section = ({ title, children }) => (
    <div className="cost-center-section mt-3">
        <div className="d-flex slide-header"><div className="param-label pt-1">{title}</div></div>
        <div className="border-box2 p-3">{children}</div>
    </div>
);

export const toSelectOptions = (list) => (list || []).map((item) => ({ value: item.value, label: item.text }));
